import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventIcon from '@mui/icons-material/Event';
import GroupsIcon from '@mui/icons-material/Groups';
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SettingsIcon from '@mui/icons-material/Settings';
// import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import { useAuth } from '../../contexts/AuthContext';
import PortalShell from '../layout/PortalShell';
import PartnerTemporaryDisableOverlay from './PartnerTemporaryDisableOverlay';

const PARTNER_NAV = [
  { label: 'Dashboard', path: '/partner-dashboard', icon: DashboardIcon },
  { label: 'Events', path: '/partner-events', icon: EventIcon },
  { label: 'Community', path: '/partner-community', icon: GroupsIcon },
  // { label: 'Aria Handsoff', path: '/partner-aria-handsoff', icon: SupportAgentIcon },
  // { label: 'Analytics', path: '/partner-analytics', icon: BarChartIcon },
  // { label: 'Manage Subscription', path: '/partner-subscription', icon: CardMembershipOutlinedIcon },
  { label: 'Settings', path: '/partner-settings', icon: SettingsIcon },
];

const PartnerLayout = ({ children, onSignOut }) => {
  const { partnerProfile } = useAuth();
  const navigate = useNavigate();
  const isTemporarilyDisabled = Boolean(
    partnerProfile?.temporaryDisable ?? partnerProfile?.partnerProfile?.temporaryDisable,
  );

  const handleSignOut = async () => {
    await onSignOut?.();
    navigate('/partner-login', { replace: true });
  };

  const user = {
    name: partnerProfile?.fullName || 'Partner',
    email: partnerProfile?.email || '',
    avatarUrl: partnerProfile?.avatarUrl || undefined,
  };

  return (
    <PortalShell
      navItems={PARTNER_NAV}
      user={user}
      notificationsPath="/partner-notifications"
      onSignOut={handleSignOut}
      signOutRedirectPath="/partner-login"
      overlay={
        isTemporarilyDisabled ? <PartnerTemporaryDisableOverlay onSignOut={handleSignOut} /> : null
      }
    >
      {children}
    </PortalShell>
  );
};

export default PartnerLayout;
